const chat = require('../../../../../components/chat/chat')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./item-fullcont-handler')


export function start(detail) {
    if (obj[detail.act]) {
        obj[detail.act].start(detail)
    }
}

const obj = {
    load: { start: (detail) => { load(detail) } },
    submit: { start: (detail) => { submit(detail) } },
    typing: { start: (detail) => { typing(detail) } },
    beforeChat: { start: (detail) => { beforeChat(detail) } },
    loadAllItems: { start: (detail) => { loadAllItems(detail) } },
}

const INVENTORY_QUESTIONS = [
    "Items below minimum stock level?",
    "Items nearing expiration?",
    "Last adjustment?",
]

const ITEMS_QUESTIONS = [
    "Current price?",
    "Stock available?",
    "Last transaction?",
]

function getGeneralQuestions(type) {
    if (type === "inventory") {
        return INVENTORY_QUESTIONS
    }

    if (type === "item") {
        return ITEMS_QUESTIONS
    }

}

function loadAllItems(detail) {
    const cardWarning = `
        <div class="row">
            <div class="c33">
                <div class="chat-type-text">
                    Entity: Inventory
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    Type: All Items
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    ID: Not available
                </div>
            </div>
        </div>

        <div class="row mt-8">
            <div class="c100">
                <div class="chat-type-text">
                    This chat is limited to this entity and to the history
                </div>
            </div>
        </div>
    `;


    chat.start(
        {
            "dest": "chat",
            "act": "quickview",
            "actQuickview": "show",
            "type": "itemAll",
            "entity": "item",
            "question": detail.question ?? "",
            "generalQuestions": getGeneralQuestions("inventory"),
            "cardWarning": cardWarning,
            "ev": detail.ev
        }
    )
}

function load(detail) {

    const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
    const recordId = fullcontActivo.getAttribute('data-dbid')

    const cardWarning = `
        <div class="row">
            <div class="c33">
                <div class="chat-type-text">
                    Entity: ${detail.dest}
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    Type: Specific Item
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    ID: ${recordId}
                </div>
            </div>
        </div>

        <div class="row mt-8">
            <div class="c100">
                <div class="chat-type-text">
                    This chat is limited to this entity and to the history of this item
                </div>
            </div>
        </div>
    `;

    if (recordId) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "item",
                "entity": "item",
                "question": detail.question ?? "",
                "recordId": recordId,
                "ev": detail.ev,
                "generalQuestions": getGeneralQuestions("item"),
                "cardWarning": cardWarning,
            }
        )

        const msj = handler.getChatsFc();
        chat.start({
            "dest": "chat",
            "act": "load",
            "chats": msj,
            "generalQuestions": getGeneralQuestions("item"),
            "cardWarning": cardWarning,
        })
    }

}

function beforeChat(detail) {

    const htmlFc = handler.getDataFc()

    const dataToSend = handler.getValuesForChat(detail, htmlFc)
    if (dataToSend) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "itemBefore",
                "entity": "item",
                "data": dataToSend,
                "question": detail.question ?? "",
                "ev": detail.ev
            }
        )
    }
}

function typing(detail) {
    chatHandler.typing(detail)
}